import React from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

export const DialogBox = ({ visible, onClose,archivedUser ,popupData}) => {
    return (
        <>
            <Dialog title={"Please confirm"} onClose={onClose}>
                <p
                    style={{
                        margin: "25px",
                        textAlign: "center",
                    }}
                >
                    {popupData === "restore" ? "Are you sure want to restore this note": "Are you sure want to archive this note"}
                </p>
                <DialogActionsBar>
                    <button
                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                        onClick={onClose}
                    >
                        No
                    </button>
                    <button
                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                        onClick={archivedUser}
                    >
                        Yes
                    </button>
                </DialogActionsBar>
            </Dialog>
        </>

    );
}

